import React, { Component, ReactNode } from 'react';
import { Error500Page } from '../pages/errors';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

/**
 * ErrorBoundary - Captura erros de runtime e exibe Error500Page
 * Fidelidade com o comportamento original do Rails
 */
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Log do erro para monitoramento (equivalente ao que o Rails faz)
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    
    // TODO: Enviar para serviço de monitoramento (Sentry, etc.)
  }

  render() {
    if (this.state.hasError) {
      return <Error500Page errorMessage={this.state.error?.message} />;
    }

    return this.props.children;
  }
}
